if (!customElements.get('bundle-form')) {
  customElements.define('bundle-form', class BundleForm extends HTMLElement {
    constructor() {
      super();
      this.submitButton = this.querySelector('[data-add-to-cart]');
      this.parentVariantId = this.dataset.parentVariantId;
      this.parentHasSellingPlans = this.dataset.parentHasSellingPlans === 'true';
      this.subProductId = this.dataset.subProductId || '';
      this.form = this.querySelector('form');
      this.productSection = this.closest('.product-section');

      if (this.form) {
        this.form.addEventListener('submit', function(evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }, true);

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.bindSubscriptionFallback();
    }

    bindSubscriptionFallback() {
      const fallback = this.productSection && this.productSection.querySelector('[data-bundle-subscription-fallback]');
      if (!fallback) return;

      const hiddenPlan = fallback.querySelector('#bundle_selling_plan');
      const planSelect = fallback.querySelector('[data-bundle-selling-plan-select]');
      const purchaseTypes = fallback.querySelectorAll('[data-bundle-purchase-type]');
      const subscriptionBox = fallback.querySelector('[data-bundle-subscription-box]');
      const subscriptionPriceEl = fallback.querySelector('[data-stayai-subscription-price]');
      const subscriptionCompareEl = fallback.querySelector('[data-stayai-subscription-compare]');

      const formatMoney = function(cents) {
        if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
          return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
        }

        return '$' + (Number(cents) / 100).toFixed(2);
      };

      const updateSubscriptionPrice = function() {
        if (!planSelect || !planSelect.selectedOptions.length) return;

        const selectedOption = planSelect.selectedOptions[0];
        if (!selectedOption.value) return;

        const planPrice = selectedOption.dataset.planPrice;
        const planCompare = selectedOption.dataset.planCompare;

        if (subscriptionPriceEl && planPrice) {
          subscriptionPriceEl.innerHTML = '<s data-stayai-subscription-compare="">' + formatMoney(planCompare) + '</s> ' + formatMoney(planPrice);
        }
      };

      const syncSellingPlan = function() {
        const subscriptionSelected = fallback.querySelector('[data-bundle-purchase-type][value="purchaseTypeSubscription"]:checked');

        if (subscriptionBox) {
          subscriptionBox.classList.toggle('is-visible', !!subscriptionSelected);
        }

        if (subscriptionSelected && planSelect && planSelect.value) {
          if (hiddenPlan) hiddenPlan.value = planSelect.value;
          updateSubscriptionPrice();
        } else if (hiddenPlan) {
          hiddenPlan.value = '';
        }
      };

      purchaseTypes.forEach(function(input) {
        input.addEventListener('change', function() {
          purchaseTypes.forEach(function(radio) {
            radio.closest('label')?.classList.toggle('is-selected', radio.checked);
          });
          syncSellingPlan();
        });
      });

      if (planSelect) {
        planSelect.addEventListener('change', syncSellingPlan);
      }

      syncSellingPlan();
    }

    getSelectedSellingPlanId() {
      const scope = this.productSection || this.closest('.product-single__meta') || document;

      const subscriptionAvailable =
        !!scope.querySelector('[data-bundle-subscription-fallback]') ||
        !!scope.querySelector('input[name="purchaseType"][value="purchaseTypeSubscription"]') ||
        !!scope.querySelector('.stayai-subscriptions input[name="purchaseType"], purchase-options input[name="purchaseType"]') ||
        this.parentHasSellingPlans;

      const masterDropdown =
        scope.querySelector('[data-bundle-plan-dropdown]') ||
        scope.querySelector('.bundle-plan-dropdown') ||
        document.querySelector('[data-bundle-plan-dropdown]') ||
        document.querySelector('.bundle-plan-dropdown');

      if (masterDropdown) {
        const value = String(masterDropdown.value || '').trim();
        if (!subscriptionAvailable || !value || value === 'onetime') {
          return null;
        }

        const planId = Number(value);
        return Number.isFinite(planId) && planId > 0 ? planId : null;
      }

      if (!subscriptionAvailable) {
        return null;
      }

      const sellingPlanInput =
        scope.querySelector('#bundle_selling_plan') ||
        (this.form && this.form.querySelector('input[name="selling_plan"]')) ||
        scope.querySelector('input[name="selling_plan"]');

      const stayAiSelect = scope.querySelector('[data-bundle-selling-plan-select]') ||
        scope.querySelector('select[name="stayai_selling_plan"]');

      const oneTimeSelected =
        scope.querySelector('input[name="purchaseType"][value="purchaseTypeOneTime"]:checked') ||
        scope.querySelector('input[value="purchaseTypeOneTime"]:checked');

      if (oneTimeSelected) {
        return null;
      }

      let planId = '';

      if (sellingPlanInput && sellingPlanInput.value) {
        planId = sellingPlanInput.value;
      } else if (stayAiSelect && stayAiSelect.value) {
        planId = stayAiSelect.value;
      }

      planId = Number(planId);
      return Number.isFinite(planId) && planId > 0 ? planId : null;
    }

    buildBundleItems(parentVariantId, childVariantIds, sellingPlanId) {
      const bundleId = 'bundle-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);

      const parentItem = {
        id: Number(parentVariantId),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_slot: 'main',
          _bundle_role: 'parent',
          _bundle_sub_product_id: this.subProductId
        }
      };

      if (sellingPlanId) {
        parentItem.selling_plan = sellingPlanId;
      }

      const items = [parentItem];

      childVariantIds.forEach(function(variantId, index) {
        const childItem = {
          id: Number(variantId),
          quantity: 1,
          parent_id: Number(parentVariantId),
          properties: {
            _bundle_id: bundleId,
            _bundle_slot: String(index + 1),
            _bundle_role: 'child',
            _bundle_sub_product_id: this.subProductId
          }
        };

        if (sellingPlanId) {
          childItem.selling_plan = sellingPlanId;
        }

        items.push(childItem);
      }.bind(this));

      return items;
    }

    getParentVariantId() {
      const productSelect = this.form && this.form.querySelector('[data-product-select]');

      if (productSelect && productSelect.value) {
        return productSelect.value;
      }

      return this.parentVariantId;
    }

    getChildVariantIds() {
      const ids = [];

      for (let i = 1; i <= 3; i++) {
        const field = document.getElementById('bundle_variant_' + i);
        if (field && field.value.trim() !== '') {
          ids.push(field.value);
        }
      }

      return ids;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.submitButton || this.submitButton.disabled) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const parentVariantId = this.getParentVariantId();
      const childVariantIds = this.getChildVariantIds();

      if (!parentVariantId) {
        this.handleErrorMessage('Bundle parent product is not configured.');
        return;
      }

      if (childVariantIds.length !== 3) {
        return;
      }

      const sellingPlanId = this.getSelectedSellingPlanId();
      const items = this.buildBundleItems(parentVariantId, childVariantIds, sellingPlanId);

      this.handleErrorMessage();
      this.submitButton.classList.add('btn--loading');
      this.submitButton.setAttribute('aria-disabled', 'true');

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data.status === 422) {
            this.handleErrorMessage(data.description || data.message);
            this.error = true;
            return;
          }

          this.error = false;

          if (theme.settings.cartType === 'page') {
            window.location = theme.routes.cartPage;
            return;
          }

          const eventTarget = this.form || document;
          eventTarget.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data,
              addToCartBtn: this.submitButton
            },
            bubbles: true
          }));

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data,
              addToCartBtn: this.submitButton
            }
          }));
        }.bind(this))
        .catch(function(error) {
          console.error(error);
          this.handleErrorMessage('Could not add bundle to cart. Please try again.');
          this.error = true;
        }.bind(this))
        .finally(function() {
          this.submitButton.classList.remove('btn--loading');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        }.bind(this));
    }

    handleErrorMessage(errorMessage) {
      const wrapper = this.querySelector('.bundle-form__error');

      if (!wrapper) return;

      const message = wrapper.querySelector('.bundle-form__error-message');
      wrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && message) {
        message.textContent = errorMessage;
      }
    }
  });
}
